import { getVariant } from '@apia/theme';
import { FC } from 'react';
import { Progress, Label } from '@apia/theme';

export interface IProgressBar {
  id: string;
  progress?: number;
  loading?: boolean;
}

const ProgressBar: FC<IProgressBar> = ({
  id,
  progress = 0,
  loading = false,
}) => {
  return (
    <>
      <Label
        htmlFor={id}
        sx={{
          display: loading ? 'block' : 'none',
          m: '0px',
        }}
      >
        {`${progress}%`}
      </Label>
      <Progress
        id={id}
        max={100}
        value={progress}
        {...getVariant('styles.progress')}
        sx={{
          display: loading ? 'block' : 'none',
        }}
      >
        {`${progress}%`}
      </Progress>
    </>
  );
};

export default ProgressBar;
